// src/pages/LogsPage.js
import React from 'react';
import { Container, Typography } from '@mui/material';
import LogViewer from '../components/LogViewer/LogViewer';

function LogsPage() {
    return (
        <Container>
            <Typography variant="h4" sx={{ my: 4 }}>
                System Logs
            </Typography>
            <LogViewer />
        </Container>
    );
}

export default LogsPage;